import { useNavigate } from "react-router-dom";
import { assetsUrl } from "../constants";
function PageNotFound() {
    const navigate = useNavigate();
    const goBack = ()=>{
        navigate(-2)
    }
  const ErrorComponent = (
    <div className="flex items-center justify-center bg-gradient-to-br">
      <div className=" bg-opacity-70 backdrop-blur-md p-10 rounded-2xl shadow-xl text-center animate-fade-in">
        <h1 className="text-7xl font-extrabold text-blue-600">404</h1>
        <p className="mt-4 text-2xl font-semibold text-gray-800">Page Not Found</p>
        <p className="mt-2 text-gray-600">
          The page you are looking for doesn't exist or has been moved.
        </p>
        <a
          onClick={goBack}
          className="cursor-pointer inline-block mt-6 px-6 py-2 text-lg font-medium text-white bg-blue-500 rounded-full hover:bg-blue-600 transition duration-300"
        >
          Go to Back
        </a>
      </div>
    </div>
  );

  const uiArray = [
    <div
    className={`flex flex-col items-start justify-start h-screen bg-cover bg-center`}
    style={{ backgroundImage: `url("${assetsUrl}/errors/404/bg1.jpg")` }}
  >
    <div className="flex items-center justify-center">
    <div className="p-10 text-center">
      <h1 className="text-7xl font-extrabold text-blue-600">404</h1>
      <p className="mt-4 text-2xl font-semibold text-gray-800">Page Not Found</p>
      <p className="mt-2 text-gray-600">
        The page you are looking for doesn't exist or has been moved.
      </p>
      <a
        onClick={goBack}
        className="cursor-pointer inline-block mt-6 px-6 py-2 text-lg font-medium text-white bg-blue-500 rounded-full hover:bg-blue-600 transition duration-300"
      >
        Go to Back
      </a>
    </div>
  </div>
  </div>,
    <div
      className={`flex flex-col items-start justify-start h-screen bg-cover bg-center`}
      style={{ backgroundImage: `url("${assetsUrl}/errors/404/bg3.jpg")` }}
    >
      <div className="py-40 px-24">{ErrorComponent}</div>
    </div>,
    <div
      className={`flex flex-col items-start justify-start h-screen bg-cover bg-center`}
      style={{ backgroundImage: `url("${assetsUrl}/errors/404/bg4.jpg")` }}
    >
      <div className="py-40 px-24">{ErrorComponent}</div>
    </div>,
  ];

  return (
    <>
     {uiArray[Math.floor(Math.random() * uiArray.length)]}
    </>
  );
}

export default PageNotFound;
